<template>
  <el-config-provider :locale="elementLocale">
    <router-view></router-view>
  </el-config-provider>
</template>

<script>
import { onMounted, ref, computed, onBeforeUnmount} from 'vue';
import { useStore } from 'vuex';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import { fetchServerList, stopAllTasks } from "@/api/http";

export default {
  name: 'App',
  components: {},
  setup() {
    const store = useStore();

    const elementLocale = computed(() => 
      store.getters.getNowTheme.lang === 'cn' ? zhCn : ''
    );

    const upColor = ref('red');
    console.log(store.state.home.activeSymbolItem, "activeSymbolItem 2");

    window.addEventListener('beforeunload', () => {
      // 刷新保存store里面的state
      localStorage.setItem('ddtrader.state', JSON.stringify(store.state));
    });

    store.dispatch('getWsUrl');
    store.dispatch('getAgentConfig');

    onMounted(() => {
      upColor.value = store.state.home.contentColor;
      onChange({ target: { value: upColor.value } }, true);

      // 加载服务器列表
      fetchServerList();
    });

    onBeforeUnmount(() => {
      stopAllTasks(); // 组件卸载时停止所有任务
    });

    const onChange = (e, f) => {
      store.commit('NOW_UP_COLOR', e.target.value);
      store.commit('NOW_THEME_COLOR', 'white');
      if (e.target.value === 'red') {
        document.body.classList.remove('green-up');
        document.body.classList.remove('blue-up');
        document.body.classList.add('red-up');
      } else if (e.target.value === 'green') {
        document.body.classList.remove('red-up');
        document.body.classList.remove('blue-up');
        document.body.classList.add('green-up');
      } else if (e.target.value === 'blue') {
        document.body.classList.remove('green-up');
        document.body.classList.remove('red-up');
        document.body.classList.add('blue-up');
      }
      if (!f) {
        location.reload();
      }
    };

    return {
      elementLocale
    };
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1200px;
}
</style>
